import { GoogleAnalyticsService } from '@grupoboticario/barril-del-chavo'

interface EventsParameters {
  name: string
  index: number
}

interface BaseEventParameters extends EventsParameters {
  cd_interaction_detail: string
}

const baseEvent = ({ cd_interaction_detail, name, index }: BaseEventParameters) => {
  const eventData = {
    event: 'analytics-event',
    event_parameters: {
      event_name: 'interaction_categorias',
      cd_interaction_detail,
      item_list_id: name.toLowerCase(),
      item_list_name: name,
      index,
    },
  }

  GoogleAnalyticsService.event(eventData)
}

export const trackCategoryClick = ({ name, index }: EventsParameters) => {
  baseEvent({ cd_interaction_detail: 'click:categoria', name, index })
}
